import NavigationBar from "../comps/NavigationBar/NavigationBar";
import Footer from "../comps/Footer/Footer";
import ContentCard from "../comps/ContentCard/ContentCard";
import Sidebar from "../comps/Sidebar/Sidebar";

export default function Software() {
  const menu = [
    {
      name: "1. BioRocket Online Platform – BioRocket",
      id: "Software-0",
    },
    {
      name: "2. Offline Tools – Visit our GitLab",
      id: "Software-1",
    },
  ];
  return (
    <div className="general-background">
      <NavigationBar />
      <Sidebar menu={menu} />
      <div className="main-container">
        <p className="title">Software:</p>
        <ContentCard
          content={` 
            <p>
            We have developed a user-friendly online platform and a scalable command-line based offline tool that are available for anyone interested in eCIS mining and analysis.
            </p>
              `}
        />
        <p className="subtitle" key={"Software-0"} id="Software-0">
          1. BioRocket Online Platform –{" "}
          <a href="http://8.134.141.78/">BioRocket</a>
        </p>
        <ContentCard
          content={` 
            <p>
            We have developed the BioRocket online platform, which integrates two major functions: database search and online prediction, catering to different user groups.
            </p>
            <br/>
            <b>1. Database Search – Designed for scientists and clinical doctors</b>
            <p>
            On the BioRocket platform, users can directly match their sequences with the data in the BioRocket terminal database by submitting sequences. Additionally, we have developed a distinctive feature tailored for our target users. When searching for afp13 homologous sequences, BioRocket will provide pre-computed programmable regions. Considering the future, research and clinical applications of eCISs will primarily focus on targeted customization. This BioRocket feature will significantly save users' time for calculations and experiments, thereby advancing the field.
            </p>
            <br/>
            <img
            src='https://static.igem.wiki/teams/4826/wiki/implementation-figure1.jpeg'
            alt='Figure 1. Users can access data from the BioRocket database online. For the afp13 homologous protein, it is also possible to view its programmable region.'
            class='content-figure'
            />
            <p class='content-legend'>
            Figure 1. Users can access data from the BioRocket database online. For the afp13 homologous protein, it is also possible to view its programmable region.
            </p>
            <br/>
            <b>2. eCIS Online Prediction – Designed for Synthetic Biologists. </b>
            <p>
            We believe that in the future, anyone can engage in synthetic biology research in any spatial environment. Therefore, we have specifically designed the eCIS online prediction feature. For individual synthetic biologists, they can use portable third-generation sequencers to obtain sequence information from environmental organisms anytime, anywhere, and upload the sequences to the BioRocket online prediction platform in real-time. By connecting to cloud servers for computations, users can quickly make preliminary assessments of whether the eCISs exist in their collected samples, providing guidance for subsequent wet experiments.
            </p>
            <br/>
            <img
            src='https://static.igem.wiki/teams/4826/wiki/implementation-figure2.png'
            alt='Figure 2. Users can submit their own genomic data for real-time eCIS mining through the BioRocket cloud server.'
            class='content-figure'
            />
            <p class='content-legend'>
            Figure 2. Users can submit their own genomic data for real-time eCIS mining through the BioRocket cloud server.
            </p>
              `}
        />
        <p className="subtitle" key={"Software-1"} id="Software-1">
          2. Offline Tools – Visit our{" "}
          <a href="https://gitlab.igem.org/2023/software-tools/sysu-software">
            GitLab
          </a>
        </p>
        <ContentCard
          content={`
            <p>
            In addition to providing the web interface version, we also provide the command line data offline tools. It is more of a powerful tool allowing users to execute the program with their customized parameters and therefore more space for customization, and it is suited for debugging or for code modification to some context.
            </p>
            <br/>
            <p>
            The BioRocket offline tool utilizes over ten prediction models to mine the input genomic sequence, identify the present eCISs, and output information about the afp homologous proteins contained within the system.
            </p>
            <br/>
            <p>
            The user guide is already written on GitLab. And the overall prediction process is also thoroughly described in <a href="https://2023.igem.wiki/sysu-software/model">Model</a>. You can check there for details.
            </p>
            <br/>
            <p>
            The program can run smoothly on the computer with the following configuration.
            </p>
            <br/>
            <div style="text-align:center">
            <img
            src='https://static.igem.wiki/teams/4826/wiki/software-figure3.png'
            alt='Figure 3. Computer configuration'
            class='content-figure'
            style='width:40%'
            />
            </div>
            <p class='content-legend'>
            Figure 3. Computer configuration
            <br/>
            <br/>
            <img
            src='https://static.igem.wiki/teams/4826/wiki/software-figure4.png'
            alt='Figure 4. Configure the program's runtime environment.'
            class='content-figure'
            />
            <p class='content-legend'>
            Figure 4. Configure the program's runtime environment.
            <br/>
            <br/>
            <img
            src='https://static.igem.wiki/teams/4826/wiki/software-figure5.png'
            alt='Figure 5. BioRocket ran successfully.'
            class='content-figure'
            />
            <p class='content-legend'>
            Figure 5. BioRocket ran successfully.
            `}
        />
      </div>
      <Footer />
    </div>
  );
}
